/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import _ from 'lodash';
import { http } from './utils';

const augmentRecording = (recording) => {
  recording.failed =  (recording.results && recording.results.status === 'failed');
  recording.processing = (recording.results && recording.results.status === 'processing');
  recording.uploading = (recording.results && recording.results.status === 'uploading');
  return recording;
};

export default {
  list(filters) {
    return http.get('recordings', { params: filters })
      .then(recordings => {
        return _.map(recordings, augmentRecording);
      });
  },
  upload(formData, options) {
    return http.post('recordings', formData, options);
  },
  post(data) {
    return http.post('recordings', data);
  },
  get(recordingId) {
    return http.get(`recordings/${recordingId}?expand=tips,timestamped`)
      .then(recording => augmentRecording(recording));
  },
  del(recordingId) {
    return http.delete(`recordings/${recordingId}`);
  },
  postChunk(recordingId, formData) {
    return http.post(`recordings/${recordingId}/chunks`, formData);
  },
  put(recordingId, data) {
    return http.put(`recordings/${recordingId}`, data);
  },
  updateSpeakerNum(recordingId, data) {
    return http.put(`recordings/${recordingId}/speaker`, data);
  }
};
